"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useStep } from "@/hooks/use-step-handler";

import { RetailClientStep } from "../client/retail-client-step";

function VehicleAssignmentRetailSteps({
  onCanProceedChange,
}: {
  onCanProceedChange?: (canProceed: boolean) => void;
}) {
  const { step } = useStep();

  if (step === 2) {
    return <RetailClientStep onCanProceedChange={onCanProceedChange} />;
  }

  return (
    <Card>
      <CardContent className="p-6 text-gray-600">
        Contenu étape {step} (WIP)
      </CardContent>
    </Card>
  );
}

export { VehicleAssignmentRetailSteps };
